import { render, staticRenderFns } from "./FilterAccordionSection.vue?vue&type=template&id=33f823af&scoped=true"
import script from "./FilterAccordionSection.vue?vue&type=script&lang=js"
export * from "./FilterAccordionSection.vue?vue&type=script&lang=js"
import style0 from "./FilterAccordionSection.vue?vue&type=style&index=0&id=33f823af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f823af",
  null
  
)

export default component.exports